export function getConfiguredLLMEndpoint(windowRef = window) {
  const configuredEndpoint = (
    windowRef.istorylineLLMEndpoint ||
    windowRef.localStorage.getItem('istoryline_llm_endpoint') ||
    ''
  ).trim()
  if (configuredEndpoint) return configuredEndpoint

  const location = windowRef.location
  const hostname = location && location.hostname
  const isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname === ''
  return isLocal || !location ? '' : `${location.origin}/summarize-selection`
}

export function getStoryInsightEndpoint(endpoint, baseHref) {
  if (!endpoint) return ''
  try {
    const url = new URL(endpoint, baseHref)
    if (url.pathname.endsWith('/summarize-selection')) {
      url.pathname = url.pathname.replace(
        /\/summarize-selection$/,
        '/story-insights'
      )
      return url.toString()
    }
    if (url.pathname.endsWith('/story-insights')) return url.toString()
    url.pathname = `${url.pathname.replace(/\/$/, '')}/story-insights`
    return url.toString()
  } catch (error) {
    if (endpoint.endsWith('/summarize-selection')) {
      return endpoint.replace(/\/summarize-selection$/, '/story-insights')
    }
    return `${endpoint.replace(/\/$/, '')}/story-insights`
  }
}

export function createTimeoutSignal(milliseconds, windowRef = window) {
  if (typeof AbortController === 'undefined') return {}
  const controller = new AbortController()
  const timeoutId = windowRef.setTimeout(() => controller.abort(), milliseconds)
  return {
    signal: controller.signal,
    cancel: () => windowRef.clearTimeout(timeoutId),
  }
}
